import React from "react";
import { subscribe } from "../actions/index";
import "../assets/css/main.css";
import logowhite from "../images/logo-white.png";
import twitterIcon from "../images/twitterIcon.svg";
import fbImg from "../images/fbImg.svg";
import youtubeImg from "../images/youtubeImg.svg";
import whatsappIcon from "../images/whatsappIcon.svg";
import mailImg from "../images/mailImg.svg";
import linkedInImg from "../images/linkedInImg.svg";

class Footer extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      email: "",
    };

    this.handleSubmit = this.handleSubmit.bind(this);
  }

  handleFormValueChange(inputName, event) {
    let stateValue = {};
    stateValue[inputName] =
      event.target.type === "checkbox"
        ? event.target.checked
        : event.target.value;
    this.setState(stateValue);
  }

  handleSubmit(event) {
    event.preventDefault();
    // get action
    const subscribeAction = subscribe(this.state);

    // Dispatch the contact from data
    this.props.dispatch(subscribeAction);

    // added delay to change button text to previous
    setTimeout(
      function () {
        // get action again to update state
        const subscribeAction = subscribe(this.state);

        // Dispatch the contact from data
        this.props.dispatch(subscribeAction);

        // clear form data
        this.setState({
          email: "",
        });
      }.bind(this),
      3000
    );
  }

  componentDidMount() {
    /**
     * Your ajax will goes here to get data then call setState
     */
  }

  render() {
    return (
      <React.Fragment>
        <footer
          className={
            "footer-1 gradient-bg " +
            (this.props.withoutNewsletter &&
            this.props.withoutNewsletter === true
              ? ""
              : "footer-with-newsletter")
          }
          style={{ marginTop: "0" }}
        >
          {!(
            this.props.withoutNewsletter &&
            this.props.withoutNewsletter === true
          ) && (
            <div className="container" style={{ display: "none" }}>
              <div className="row newsletter-wrap primary-bg rounded shadow-lg p-5">
                <div className="col-md-6 col-lg-7 mb-4 mb-md-0 mb-sm-4 mb-lg-0">
                  <div className="newsletter-content text-white">
                    <h3 className="text-white">
                      Join our teachers' Facebook community
                    </h3>
                    <p className="mb-0">
                      EdTalks by Classplus is India’s largest community of
                      teachers to help them learn, ideate, and grow with each
                      other.
                    </p>
                  </div>
                </div>
                <div className="col-md-6 col-lg-5">
                  <form
                    className="newsletter-form position-relative"
                    method="post"
                    onSubmit={this.handleSubmit}
                  >
                    {/* <input value={this.state.email} onChange={e => this.handleFormValueChange("email", e)} type="text" className="input-newsletter form-control" placeholder="Enter your email" name="email" required="" />*/}
                    <button type="submit">
                      <a href="https://m.facebook.com/groups/661917880814184?group_view_referrer=profile_browser">
                        Join Now
                      </a>
                    </button>
                  </form>
                </div>
              </div>
            </div>
          )}

          <div className="container">
            {/*<div className="row">
                            <div className="col-md-12 col-lg-4 mb-4 mb-md-4 mb-sm-4 mb-lg-0">
                                <a href=" https://www.classplusapp.com" className="navbar-brand mb-2">
                                    <img src={logowhite} alt="logo" className="img-fluid" />
                                </a>
                                <br />
                                <p></p>
                                <div className="list-inline social-list-default background-color social-hover-2 mt-2">
                                    <li className="list-inline-item"><a className="facebook" href="https://www.facebook.com/classplusapp"><i className="fab fa-facebook"></i></a></li>
                                    <li className="list-inline-item"><a className="gmail" href="mailto:support@classplusapp.com"><i className="fa fa-envelope"></i></a></li>
                                    <li className="list-inline-item"><a className="youtube" href="https://www.youtube.com/channel/UCp0yDDnyu-C-0Bo_y1JbGtA/featured"><i className="fab fa-youtube"></i></a></li>
                                    <li className="list-inline-item"><a className="linkedin" href="https://www.linkedin.com/company/10177906/"><i className="fab fa-linkedin-in"></i></a></li>
                                    <li className="list-inline-item"><a className="whatsapp" href="https://api.whatsapp.com/send?phone=917290085264&text=Hi%20Classplus,%20I%20would%20like%20to%20know%20more%20about%20your%20Complete%20Coaching%20Solution"><i className="fab fa-whatsapp-square"></i></a></li>
                                </div>
                            </div>
                            <div className="col-md-12 col-lg-8">
                                <div className="row mt-0">
                                    <div className="col-sm-6 col-md-6 col-lg-6 mb-4 mb-sm-4 mb-md-0 mb-lg-0">
                                        <h6 className="text-uppercase">Classplus</h6>
                                        <ul>
                                            <li>
                                                <a href="/#">About us</a>
                                            </li>
                                            <li>
                                                <a href="/#">Product</a>
                                            </li>
                                            <li>
                                                <a href="/#">Classplus Academy</a>
                                            </li>
                                            <li>
                                                <a href="/#">Contact Us</a>
                                            </li>
                                            <li>
                                                <a href="/privacyPolicy">Privacy Policy</a>
                                            </li>
                                            <li>
                                                <a href="faq">Terms & Condition</a>
                                            </li>
                                            <li>
                                                <a href="/#">Sitemap</a>
                                            </li>
                                        </ul>
                                    </div>
                                    <div className="col-sm-6 col-md-6 col-lg-6">
                                        <h6 className="text-uppercase">Contact Info</h6>
                                        <ul>
                                            <li>
                                                <a>1st Floor, D8, Sector 3</a>
                                            </li>
                                            <li>
                                                <a>Noida, Uttar Pradesh 201301</a>
                                            </li>
                                            <li>
                                                <a><i className="fa fa-mobile mr-2"></i>+91-9090404009</a>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                     </div>*/}
            <div className="sg-footer-content">
              <div className="sg-footer-content-logo">
                <a
                  target="_blank"
                  href=" https://www.classplusapp.com"
                  className="navbar-brand mb-2"
                >
                  <img src={logowhite} alt="logo" className="img-fluid" />
                </a>
              </div>
              <div className="sg-footer-content-classplus">
                <h6 className="text-uppercase">Classplus</h6>
                <ul>
                  <li>
                    <a target="_blank" href="https://classplusapp.com/aboutus">
                      About us
                    </a>
                  </li>
                  {/* <li>
                    <a target="_blank" href="https://classplusapp.com/products">
                      Product
                    </a>
                  </li> */}
                  <li>
                    <a
                      target="_blank"
                      href="https://classplusapp.com/teachers-delight"
                    >
                      Teachers' Delight
                    </a>
                  </li>
                  <li>
                    <a
                      target="_blank"
                      href="https://classplusapp.com/contactus"
                    >
                      Contact Us
                    </a>
                  </li>
                  <li>
                    <a
                      target="_blank"
                      href="https://classplusapp.com/privacyPolicy"
                    >
                      Privacy Policy
                    </a>
                  </li>
                  <li>
                    <a
                      target="_blank"
                      href="https://classplusapp.com/termscondition"
                    >
                      Terms & Condition
                    </a>
                  </li>
                  <li>
                    <a target="_blank" href="https://classplusapp.com/#">
                      Sitemap
                    </a>
                  </li>
                </ul>
              </div>
              <div className="sg-footer-content-contactInfo">
                <h6 className="text-uppercase">Contact Info</h6>
                <ul>
                  <li>
                    <a>1st Floor, D8, Sector 3</a>
                  </li>
                  <li>
                    <a>Noida, Uttar Pradesh 201301</a>
                  </li>
                  <li>
                    <a>
                      <i className="fa fa-mobile mr-2"></i>+91-9090404009
                    </a>
                  </li>
                </ul>
              </div>
              <div className="sg-footer-content-connectWithUs">
                <div className="list-inline social-list-default background-color social-hover-2">
                  <h6 className="text-uppercase">CONNECT WITH US</h6>
                  <li className="list-inline-item">
                    <a
                      className="facebook"
                      target="_blank"
                      href="https://www.facebook.com/classplusapp"
                    >
                      <img src={fbImg} alt="" style={{ width: "24px" }} />
                    </a>
                  </li>
                  <li className="list-inline-item">
                    <a
                      className="gmail"
                      target="_blank"
                      href="mailto:support@classplusapp.com"
                    >
                      <img src={mailImg} alt="" style={{ width: "24px" }} />
                    </a>
                  </li>
                  <li className="list-inline-item">
                    <a
                      className="youtube"
                      target="_blank"
                      href="https://www.youtube.com/channel/UCp0yDDnyu-C-0Bo_y1JbGtA/featured"
                    >
                      <img src={youtubeImg} alt="" style={{ width: "24px" }} />
                    </a>
                  </li>
                  <li className="list-inline-item">
                    <a
                      className="linkedin"
                      target="_blank"
                      href="https://www.linkedin.com/company/10177906/"
                    >
                      <img src={linkedInImg} alt="" style={{ width: "24px" }} />
                    </a>
                  </li>
                  <li className="list-inline-item">
                    <a
                      className="whatsapp"
                      target="_blank"
                      href="https://api.whatsapp.com/send?phone=917290085264&text=Hi%20Classplus,%20I%20would%20like%20to%20know%20more%20about%20your%20Complete%20Coaching%20Solution"
                    >
                      <img
                        src={whatsappIcon}
                        alt=""
                        style={{ width: "24px" }}
                      />
                    </a>
                  </li>
                  <li className="list-inline-item">
                    <a
                      className="linkedin"
                      target="_blank"
                      href="https://twitter.com/classplus_app"
                    >
                      <img src={twitterIcon} alt="" style={{ width: "24px" }} />
                    </a>
                  </li>
                </div>
              </div>
            </div>
          </div>
        </footer>
        <div className="footer-bottom py-3 gray-light-bg">
          <div className="container">
            <div className="row">
              <div className="col-md-12 col-lg-7 m-lr-9">
                <div className="copyright-wrap small-text">
                  <p className="mb-0">
                    &copy; 2020 Bunch Microtechnologies Pvt Ltd. All Rights
                    Reserved
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </React.Fragment>
    );
  }
}

export default Footer;
